import Vue from 'vue'
import Index from './index.vue'

let messageInstance = null
let MessageConstructor = Vue.extend(Index)

let init = () => {
  messageInstance = new MessageConstructor()
  messageInstance.$mount()
  document.body.appendChild(messageInstance.$el)
}

function Caller() {}

Caller.prototype.add = function (options) {
  this.options = options;
  if (!messageInstance) {
    init()
  }
  messageInstance.add(this.options)
}

Caller.prototype.remove = function () {
  messageInstance.remove_notice()
}



export default {
  // 返回 install 函数 用于 Vue.use 注册
  install(vue) {
    vue.prototype.$wx_loading = new Caller();
  }
}
